/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_EyebrowInputs */

const en_directory_api_reference_eyebrow = /** @type {(inputs: Directory_Api_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API reference`)
};

const zh_directory_api_reference_eyebrow = /** @type {(inputs: Directory_Api_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 参考`)
};

/**
* | output |
* | --- |
* | "API reference" |
*
* @param {Directory_Api_Reference_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_eyebrow = /** @type {((inputs?: Directory_Api_Reference_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_eyebrow(inputs)
	return zh_directory_api_reference_eyebrow(inputs)
});
export { directory_api_reference_eyebrow as "directory.api_reference.eyebrow" }